export function unslugify(value: string): string {
    if (!value) return value;
    // Replace hyphens and underscores with spaces and capitalize the first letter of each word
    return value
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  
}
  